import * as React from 'react';
import classNames from 'classnames';
import Image from '../Image/viewer/Image';
import { GalleryItemProps } from './GalleryItem.types';
import { TestIds } from './constants';
import ItemClickActionWrapper from './ItemClickActionWrapper';

const SlideShowGalleryItem = (props: GalleryItemProps) => {
  const {
    dataId,
    title,
    description,
    link,
    image,
    skinsStyle,
    extraClassNames,
    shouldPreserveAspectRatio,
    imageOnClickAction,
    openImageZoom = () => {},
    translate,
    alignTextRight,
    itemClickHandler,
  } = props;

  const openImageZoomCallback = React.useCallback(() => openImageZoom(dataId), [
    dataId,
    openImageZoom,
  ]);

  return (
    <div
      className={classNames(skinsStyle.root, extraClassNames.root, {
        [skinsStyle.flexibleHeight]: shouldPreserveAspectRatio,
        [skinsStyle.textAlignmentRight]: alignTextRight,
      })}
      data-testid={TestIds.item}
      onClick={itemClickHandler}
    >
      <ItemClickActionWrapper
        imageOnClickAction={imageOnClickAction}
        openImageZoom={openImageZoomCallback}
        link={link}
        imgAlt={image.alt}
        skinsStyle={skinsStyle}
        translate={translate}
      >
        <div className={skinsStyle.imageWrapper}>
          {shouldPreserveAspectRatio && (
            <svg
              className={skinsStyle.sizer}
              viewBox={`0 0 ${image.width} ${image.height}`}
            />
          )}
          <div className={skinsStyle.imageBorder}>
            <Image
              className={skinsStyle.image}
              id={`img_${image.containerId}`}
              {...image}
            />
          </div>
        </div>
        <div
          data-testid={TestIds.panel}
          className={classNames(skinsStyle.panel, extraClassNames.panel)}
        >
          <h3 data-testid={TestIds.title} className={skinsStyle.title}>
            {title}
          </h3>
          <p
            data-testid={TestIds.description}
            className={skinsStyle.description}
          >
            {description}
          </p>
        </div>
      </ItemClickActionWrapper>
    </div>
  );
};

export default SlideShowGalleryItem;
